import React, { useState, useEffect, useMemo } from "react";
import Header from "../../../Header/OxyloansAdminHeader";
import {
  getPendingBorrowerList,
  updateBorrowerComment,
} from "../../../HttpRequest/admin";
import Footer from "../../../Footer/Footer";
import OxyloansAdminSidebar from "../../../SideBar/OxyloansAdminSidebar";

const defaultNames = ["Swathi", "Aruna", "Hema", "Jyothi"];
const PAGE_SIZE = 50;
const DISPLAY_SIZE = 30;

const CALLING_STATUS_OPTIONS = [
  "Reachable",
  "Not Reachable",
  "Invalid Number",
  "Call Not Answered",
  "Switched Off",
  "Network Connectivity Issue",
  "Line Busy",
  "Out of Network Coverage",
  "Call Not Connected",
  "Call Back Later",
  "Call Rejected",
  "Other",
];

const FailedBorrowers = () => {
  const [borrowers, setBorrowers] = useState([]);
  const [selectedName, setSelectedName] = useState("Swathi");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [apiPage, setApiPage] = useState(1);
  const [displayPage, setDisplayPage] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);

  const [activeTab, setActiveTab] = useState("all");

  const [selectedBorrower, setSelectedBorrower] = useState(null);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [comment, setComment] = useState("");
  const [savingComment, setSavingComment] = useState(false);
  const [otherComment, setOtherComment] = useState("");
  const [commentError, setCommentError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const isValidComment = (value) => {
    if (value === null || value === undefined) return false;
    const text = String(value).trim();
    return text !== "" && text.toLowerCase() !== "null";
  };

  const fetchBorrowers = async (name, pageNo = 1, resetDisplay = true) => {
    setLoading(true);
    setError(null);

    if (resetDisplay) setDisplayPage(1);

    try {
      const response = await getPendingBorrowerList(pageNo, PAGE_SIZE, name);
      const data = response?.data;

      const list = Array.isArray(data)
        ? data
        : Array.isArray(data?.data)
          ? data.data
          : Array.isArray(data?.content)
            ? data.content
            : Array.isArray(data?.borrowers)
              ? data.borrowers
              : [];

      setBorrowers(list);
      setHasNextPage(list.length === PAGE_SIZE);
    } catch (err) {
      setError("Failed to fetch borrowers");
      setBorrowers([]);
      setHasNextPage(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBorrowers(selectedName, apiPage);
  }, [selectedName, apiPage]);

  const handleNameChange = (name) => {
    setSelectedName(name);
    setSearchTerm("");
    setActiveTab("all");
    setApiPage(1);
    setDisplayPage(1);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSearchTerm("");
    setDisplayPage(1);
  };

  const handleCommentClick = (borrower) => {
    setSelectedBorrower(borrower);

    const existing = isValidComment(borrower.comments)
      ? String(borrower.comments).trim()
      : "";

    const isOther =
      existing && !CALLING_STATUS_OPTIONS.slice(0, -1).includes(existing);

    setComment(isOther ? "Other" : existing);
    setOtherComment(isOther ? existing : "");
    setCommentError(null);
    setShowCommentModal(true);
  };

  const closeCommentModal = () => {
    setShowCommentModal(false);
    setComment("");
    setOtherComment("");
    setCommentError(null);
    setSelectedBorrower(null);
  };

  const handleSaveComment = async () => {
    if (!selectedBorrower) return;

    const finalComment =
      comment === "Other" ? otherComment.trim() : comment.trim();

    if (!finalComment) {
      setCommentError(
        comment === "Other"
          ? "Please enter a comment."
          : "Please select calling status.",
      );
      return;
    }

    setSavingComment(true);
    setCommentError(null);

    try {
      await updateBorrowerComment(selectedBorrower.id, finalComment);

      setBorrowers((prev) =>
        prev.map((item) =>
          item.id === selectedBorrower.id
            ? { ...item, comments: finalComment }
            : item,
        ),
      );

      closeCommentModal();
    } catch (err) {
      setCommentError("Failed to save comment. Please try again.");
    } finally {
      setSavingComment(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setDisplayPage(1);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setDisplayPage(1);
  };

  const pendingBorrowers = useMemo(
    () => borrowers.filter((b) => !isValidComment(b.comments)),
    [borrowers],
  );
const allBorrowers = useMemo(() => borrowers, [borrowers]);
  const updatedBorrowers = useMemo(
    () => borrowers.filter((b) => isValidComment(b.comments)),
    [borrowers],
  );

const tabBorrowers =
  activeTab === "all"
    ? allBorrowers
    : activeTab === "updated"
      ? updatedBorrowers
      : pendingBorrowers;

  const filteredBorrowers = searchTerm.trim()
    ? tabBorrowers.filter(
        (b) =>
          b.borrowerName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          String(b.borrowerId || "").includes(searchTerm) ||
          String(b.phone || "").includes(searchTerm),
      )
    : tabBorrowers;

  const safeFixed = (val) =>
    val !== null && val !== undefined && !isNaN(val)
      ? Number(val).toFixed(2)
      : "0.00";

  const totalDisplayPages = Math.max(
    1,
    Math.ceil(filteredBorrowers.length / DISPLAY_SIZE),
  );

  const displayStart = (displayPage - 1) * DISPLAY_SIZE;
  const displayedBorrowers = filteredBorrowers.slice(
    displayStart,
    displayStart + DISPLAY_SIZE,
  );

  const startRecord = filteredBorrowers.length === 0 ? 0 : displayStart + 1;

  const endRecord = Math.min(
    displayStart + DISPLAY_SIZE,
    filteredBorrowers.length,
  );

  const pageNumbers = Array.from({ length: totalDisplayPages }, (_, i) => i + 1)
    .filter(
      (p) =>
        p === 1 || p === totalDisplayPages || Math.abs(p - displayPage) <= 1,
    )
    .reduce((acc, p, i, arr) => {
      if (i > 0 && p - arr[i - 1] > 1) acc.push("...");
      acc.push(p);
      return acc;
    }, []);
const handleApiPrevious = () => {
  if (apiPage > 1) {
    setApiPage((p) => p - 1);
    setDisplayPage(1);
  }
};

const handleApiNext = () => {
  setApiPage((p) => p + 1);
  setDisplayPage(1);
};
  return (
    <div className="main-wrapper">
      <Header />
      <OxyloansAdminSidebar />

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col-6">
                <h3 className="page-title mb-0">Pending Borrowers</h3>
              </div>

              <div className="col-6">
                <div className="d-flex flex-column align-items-end">
                  <label
                    className="mb-1"
                    style={{ fontWeight: "600", fontSize: "13px" }}
                  >
                    Select Allocator Name
                  </label>

                  <select
                    className="form-control form-control-sm"
                    style={{ maxWidth: "200px" }}
                    value={selectedName}
                    onChange={(e) => handleNameChange(e.target.value)}
                  >
                    {defaultNames.map((name) => (
                      <option key={name} value={name}>
                        {name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className=" mb-3">
            <div className="card-body px-0 py-2">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center gap-3">
                <div className="d-flex flex-column flex-sm-row gap-2 flex-wrap">
                  <button
                    className={`btn btn-sm px-4 py-2 d-flex align-items-center justify-content-center shadow-md rounded-md fw-semibold ${
                      activeTab === "all"
                        ? "text-dark border-0"
                        : "btn-light border text-dark"
                    }`}
                    onClick={() => handleTabChange("all")}
                    style={{
                      background:
                        activeTab === "all"
                          ? "linear-gradient(135deg, #f8f9fa, #ffffff)"
                          : "#ffffff",
                      minWidth: "140px",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <span className="me-1">ALL</span>

                    <span
                      className="badge rounded-pill ml-1"
                      style={{
                        background: activeTab === "all" ? "#212529" : "#f1f3f5",
                        color: activeTab === "all" ? "#ffffff" : "#212529",
                        fontSize: "11px",
                        padding: "5px 8px",
                        fontWeight: "600",
                      }}
                    >
                      {borrowers.length}
                    </span>
                  </button>

                  <button
                    className={`btn btn-sm px-4 py-2 d-flex align-items-center justify-content-center shadow-md rounded-md fw-semibold transition-all ${
                      activeTab === "updated"
                        ? "text-white border-0"
                        : "btn-light border text-success"
                    }`}
                    onClick={() => handleTabChange("updated")}
                    style={{
                      background:
                        activeTab === "updated"
                          ? "linear-gradient(135deg, #198754, #157347)"
                          : "#fff",
                      minWidth: "190px",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <span className="me-1">Comments Updated</span>

                    <span
                      className="badge rounded-pill ml-2"
                      style={{
                        background:
                          activeTab === "updated" ? "#ffffff" : "#198754",
                        color: activeTab === "updated" ? "#198754" : "#ffffff",
                        fontSize: "11px",
                        padding: "5px 8px",
                      }}
                    >
                      {updatedBorrowers.length}
                    </span>
                  </button>

                  <button
                    className={`btn btn-sm px-4 py-2 d-flex align-items-center justify-content-center shadow-md rounded-md fw-semibold transition-all ${
                      activeTab === "pending"
                        ? "text-white border-0"
                        : "btn-light border text-primary"
                    }`}
                    onClick={() => handleTabChange("pending")}
                    style={{
                      background:
                        activeTab === "pending"
                          ? "linear-gradient(135deg, #0d6efd, #0b5ed7)"
                          : "#fff",
                      minWidth: "190px",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <span className="me-1">Comments Pending</span>

                    <span
                      className="badge rounded-pill ml-2"
                      style={{
                        background:
                          activeTab === "pending" ? "#ffffff" : "#0d6efd",
                        color: activeTab === "pending" ? "#0d6efd" : "#ffffff",
                        fontSize: "11px",
                        padding: "5px 8px",
                      }}
                    >
                      {pendingBorrowers.length}
                    </span>
                  </button>
                </div>

                <div className="d-flex align-items-center justify-content-center justify-content-md-end gap-2 flex-wrap">
                  <button
                    className="btn btn-sm btn-outline-secondary px-3 py-2"
                    disabled={apiPage === 1 || loading}
                    onClick={handleApiPrevious}
                  >
                    <i className="fa-solid fa-angle-left me-1"></i>
                    Previous
                  </button>

                  <div
                    className="px-3 py-2 rounded-pill border text-dark"
                    style={{
                      fontSize: "13px",
                      fontWeight: "600",
                      minWidth: "90px",
                      textAlign: "center",
                    }}
                  >
                    Page {apiPage}
                  </div>

                  <button
                    className="btn btn-sm btn-outline-primary px-3 py-2"
                    disabled={loading}
                    onClick={handleApiNext}
                  >
                    Next
                    <i className="fa-solid fa-angle-right ms-1"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {loading && (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status" />
              <p className="mt-2 text-muted mb-0">Loading borrowers...</p>
            </div>
          )}

          {error && (
            <div className="alert alert-danger d-flex align-items-center gap-2">
              <i className="fa-solid fa-circle-exclamation"></i> {error}
            </div>
          )}

          {!loading && (
            <div className="card shadow-sm border-0">
              <div className="card-body p-0">
                <div className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom bg-white flex-wrap gap-2">
                  <small className="text-muted">
                    Showing <strong>{startRecord}</strong>–
                    <strong>{endRecord}</strong> of{" "}
                    <strong>{filteredBorrowers.length}</strong>
                    {searchTerm && (
                      <>
                        {" "}
                        results &nbsp;
                        <span className="badge badge-secondary">
                          {tabBorrowers.length} total
                        </span>
                      </>
                    )}
                  </small>

                  <div
                    className="position-relative"
                    style={{ minWidth: "280px" }}
                  >
                    <i
                      className="fa-solid fa-magnifying-glass"
                      style={{
                        position: "absolute",
                        left: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#aaa",
                        fontSize: "13px",
                        zIndex: 1,
                      }}
                    />

                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Search by Name, ID or Phone..."
                      value={searchTerm}
                      onChange={handleSearchChange}
                      style={{ paddingLeft: "30px", paddingRight: "30px" }}
                    />

                    {searchTerm && (
                      <i
                        className="fa-solid fa-xmark"
                        onClick={handleClearSearch}
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#999",
                          cursor: "pointer",
                          fontSize: "13px",
                        }}
                        title="Clear search"
                      />
                    )}
                  </div>
                </div>

                {displayedBorrowers.length > 0 ? (
                  <>
                    <div className="table-responsive">
                      <table className="table table-striped table-hover mb-0">
                        <thead className="thead-dark">
                          <tr>
                            <th>Borrower Info</th>
                            <th>Loan Details</th>
                            <th>Pending Details</th>
                            <th>Tenure & Location</th>
                            <th>Comments</th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {displayedBorrowers.map((borrower) => (
                            <tr key={borrower.id}>
                              <td>
                                <div style={{ fontSize: "15px" }}>
                                  <div>
                                    <strong>Name:</strong>{" "}
                                    <strong>{borrower.borrowerName}</strong>
                                  </div>
                                  <div>
                                    <strong>ID:</strong> {borrower.borrowerId}
                                  </div>
                                  <div>
                                    <strong>Phone:</strong> {borrower.phone}
                                  </div>
                                  <div>
                                    <strong>Email:</strong> {borrower.emailId}
                                  </div>
                                </div>
                              </td>

                              <td>
                                <div style={{ fontSize: "15px" }}>
                                  <div>
                                    <strong>Loan Amt:</strong>{" "}
                                    <strong>
                                      ₹{safeFixed(borrower.loanAmount)}
                                    </strong>
                                  </div>
                                  <div>
                                    <strong>EMI Amt:</strong> ₹
                                    {safeFixed(borrower.emiAmt)}
                                  </div>
                                </div>
                              </td>

                              <td>
                                <div style={{ fontSize: "15px" }}>
                                  <div>
                                    <strong>Amt Pending:</strong> ₹
                                    {safeFixed(borrower.amountPending)}
                                  </div>
                                  <div>
                                    <strong>Penalty:</strong> ₹
                                    {safeFixed(borrower.totalPenalty)}
                                  </div>
                                  <div>
                                    <strong>Total Pending:</strong> ₹
                                    {safeFixed(
                                      borrower.totalAmountPendingWithPenalty,
                                    )}
                                  </div>
                                </div>
                              </td>

                              <td>
                                <div style={{ fontSize: "15px" }}>
                                  <div>
                                    <strong>Tenure:</strong> {borrower.tenure}{" "}
                                    mo
                                  </div>
                                  <div>
                                    <strong>Location:</strong>{" "}
                                    {borrower.location}
                                  </div>
                                </div>
                              </td>

                              <td>
                                <div style={{ fontSize: "15px" }}>
                                  {isValidComment(borrower.comments) ? (
                                    <span className="badge badge-success p-2">
                                      {borrower.comments}
                                    </span>
                                  ) : (
                                    <span className="badge badge-warning p-2">
                                      No Comments
                                    </span>
                                  )}
                                </div>
                              </td>

                              <td>
                                <button
                                  className="btn btn-sm btn-info text-white"
                                  onClick={() => handleCommentClick(borrower)}
                                  title="Add/View Comments"
                                >
                                  <i className="fa-solid fa-comment me-1"></i>{" "}
                                  {isValidComment(borrower.comments)
                                    ? "Edit"
                                    : "Add"}
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {totalDisplayPages > 1 && (
                      <div
                        className="d-flex justify-content-between align-items-center px-3 py-3 border-top bg-white flex-wrap gap-2"
                        style={{ minHeight: "64px" }}
                      >
                        <small className="text-muted">
                          Page <strong>{displayPage}</strong> of{" "}
                          <strong>{totalDisplayPages}</strong>
                        </small>

                        <nav>
                          <ul className="pagination pagination-sm mb-0">
                            <li
                              className={`page-item ${
                                displayPage === 1 ? "disabled" : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => setDisplayPage(1)}
                              >
                                «
                              </button>
                            </li>

                            <li
                              className={`page-item ${
                                displayPage === 1 ? "disabled" : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() =>
                                  setDisplayPage((p) => Math.max(1, p - 1))
                                }
                              >
                                ‹
                              </button>
                            </li>

                            {pageNumbers.map((p, i) =>
                              p === "..." ? (
                                <li
                                  key={`e-${i}`}
                                  className="page-item disabled"
                                >
                                  <span className="page-link">…</span>
                                </li>
                              ) : (
                                <li
                                  key={p}
                                  className={`page-item ${
                                    p === displayPage ? "active" : ""
                                  }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() => setDisplayPage(p)}
                                  >
                                    {p}
                                  </button>
                                </li>
                              ),
                            )}

                            <li
                              className={`page-item ${
                                displayPage === totalDisplayPages
                                  ? "disabled"
                                  : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() =>
                                  setDisplayPage((p) =>
                                    Math.min(totalDisplayPages, p + 1),
                                  )
                                }
                              >
                                ›
                              </button>
                            </li>

                            <li
                              className={`page-item ${
                                displayPage === totalDisplayPages
                                  ? "disabled"
                                  : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() =>
                                  setDisplayPage(totalDisplayPages)
                                }
                              >
                                »
                              </button>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="alert alert-warning text-center m-3">
                    <i className="fa-solid fa-circle-info me-2"></i>
                    No borrowers found in{" "}
                    <strong>
                      {activeTab === "all"
                        ? "ALL"
                        : activeTab === "updated"
                          ? "Comments Updated"
                          : "Comments Pending"}
                    </strong>{" "}
                    tab for <strong>{selectedName}</strong>.
                  </div>
                )}
              </div>
            </div>
          )}

          {showCommentModal && (
            <div
              className="modal fade show"
              style={{
                display: "block",
                backgroundColor: "rgba(0,0,0,0.5)",
              }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      <i className="fa-solid fa-comment me-2 text-info"></i>
                      Comments — {selectedBorrower?.borrowerName}
                    </h5>

                    <button
                      type="button"
                      className="close"
                      onClick={closeCommentModal}
                      disabled={savingComment}
                    >
                      <span>&times;</span>
                    </button>
                  </div>

                  <div className="modal-body">
                    {isValidComment(selectedBorrower?.comments) && (
                      <div
                        className="alert alert-info py-2 px-3 mb-2"
                        style={{ fontSize: "13px" }}
                      >
                        <span className="text-muted">Existing:</span>{" "}
                        {selectedBorrower.comments}
                      </div>
                    )}

                    <select
                      className={`form-control ${
                        commentError ? "is-invalid" : ""
                      }`}
                      value={comment}
                      onChange={(e) => {
                        setComment(e.target.value);
                        if (commentError) setCommentError(null);
                      }}
                    >
                      <option value="">Select Calling Status</option>
                      {CALLING_STATUS_OPTIONS.map((status) => (
                        <option key={status} value={status}>
                          {status}
                        </option>
                      ))}
                    </select>

                    {comment === "Other" && (
                      <input
                        className={`form-control ${
                          commentError ? "is-invalid" : ""
                        } mt-3`}
                        type="text"
                        placeholder="Enter your comment..."
                        value={otherComment}
                        onChange={(e) => {
                          setOtherComment(e.target.value);
                          if (commentError) setCommentError(null);
                        }}
                      />
                    )}

                    {commentError && (
                      <div
                        className="invalid-feedback d-block"
                        style={{ fontSize: "13px" }}
                      >
                        <i className="fa-solid fa-circle-exclamation me-1"></i>
                        {commentError}
                      </div>
                    )}
                  </div>

                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={closeCommentModal}
                      disabled={savingComment}
                    >
                      Cancel
                    </button>

                    <button
                      className="btn btn-primary"
                      onClick={handleSaveComment}
                      disabled={savingComment}
                    >
                      {savingComment ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-1"
                            role="status"
                          />{" "}
                          Saving...
                        </>
                      ) : (
                        <>
                          <i className="fa-solid fa-floppy-disk me-1"></i> Save
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default FailedBorrowers;
